//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../Die/Die.DiePlaneBuilder.js";
import "../no/Expression.js";
import "../no/SelectCartesianCoordinateSystem.js";
import "../no/Section.js";
import "../Die/Die.DieDirectionBuilder.js";
import "../Die/Die.DieLocationsBuilder.js";
import "../Die/Die.DieAttributesBuilder.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"AngleTolerance",1,0],[1,"BasePlane",0,"Die.DiePlaneBuilder",0],[1,"CenterlineLength",0,"Expression",0],[1,"DieCenterlineCoordinateSystem",0,"SelectCartesianCoordinateSystem",0],[0,"DistanceTolerance",1,0],[1,"FlangeBaseProfile",0,"Section",0],[1,"FlangeThickness",0,"Expression",0],[1,"InnerWidth",0,"Expression",0],[1,"LocationOffset",0,"Expression",0],[1,"LocationOffsetDirection",0,"Die.DieDirectionBuilder",0],[0,"LocationOnFlange",1,0],[1,"Locations",0,"Die.DieLocationsBuilder",0],[1,"NotchAngle",0,"Expression",0],[1,"NotchFacesAttributes",0,"Die.DieAttributesBuilder",0],[1,"NotchHeight",0,"Expression",0],[1,"NotchWidth",0,"Expression",0],[1,"OffsetWidth",0,"Expression",0],[1,"OrientationPlane",0,"Die.DiePlaneBuilder",0],[1,"Overhang",0,"Expression",0],[1,"OverhangFacesAttributes",0,"Die.DieAttributesBuilder",0],[1,"PadFacesAttributes",0,"Die.DieAttributesBuilder",0],[1,"PadHeight",0,"Expression",0],[1,"PadLength",0,"Expression",0],[1,"PadOffset",0,"Expression",0],[1,"PadRadius",0,"Expression",0],[1,"PadWidth",0,"Expression",0],[1,"SlotEndFacesAttributes",0,"Die.DieAttributesBuilder",0],[1,"SlotFacesAttributes",0,"Die.DieAttributesBuilder",0],[1,"SlotLength",0,"Expression",0],[1,"SlotRadius",0,"Expression",0],[1,"SlotWidth",0,"Expression",0],[1,"Target",0,"SelectNXObject",0],[1,"TopLength",0,"Expression",0],[0,"Type",1,0]],[],[]];
SPLM.Die.ClampingSlotBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.ClampingSlotBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.ClampingSlotBuilder.Types = Object.freeze({
    "Hydraulic" : "Hydraulic", "Traveling" : "Traveling", "Automatic" : "Automatic"});

export default SPLM;